import type {
  LabsJourneyPromotionalPrice,
  LabsPromotionalPrice,
} from "@shared/types/graphqlGenerated";

type LabPromotionalPriceDisplay = Pick<
  LabsPromotionalPrice | LabsJourneyPromotionalPrice,
  "currentPrice" | "discountAmount" | "originalPrice"
>;

const hasDisplayableLabPromotionalPrice = (
  promotionalPrice?: LabPromotionalPriceDisplay | null
): promotionalPrice is LabPromotionalPriceDisplay =>
  !!promotionalPrice &&
  promotionalPrice.discountAmount > 0 &&
  promotionalPrice.currentPrice < promotionalPrice.originalPrice;

export { hasDisplayableLabPromotionalPrice, type LabPromotionalPriceDisplay };
